export const staircaseConfig = {
    gameSlug: 'verbal-fluency',
    category: 'foudre_logique',
    variable: 'duration_ms',
    startValue: 60_000,
    minValue: 30_000,
    maxValue: 90_000,
    stepSizesByPhase: [15_000, 7_500, 5_000, 2_500],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    /** 1 trial = 1 round 30-90 s ; cap à 6 (durée totale ~5-9 min max). */
    maxTrials: 6,
    direction: 'down-easier',
};
function buildVariant(level) {
    if (level <= 10) {
        return {
            level,
            roundMs: 90_000,
            mode: 'semantic',
            targetScore: 8,
            label: 'Catégorie familière',
        };
    }
    if (level <= 20) {
        return {
            level,
            roundMs: 60_000,
            mode: 'semantic',
            targetScore: 10,
            label: 'Catégorie standard',
        };
    }
    if (level <= 30) {
        return {
            level,
            roundMs: 60_000,
            mode: 'phonemic',
            targetScore: 8,
            label: 'Lettre standard',
        };
    }
    if (level <= 40) {
        return {
            level,
            roundMs: 45_000,
            mode: 'phonemic',
            targetScore: 8,
            label: 'Lettre sous pression',
        };
    }
    return {
        level,
        roundMs: 30_000,
        mode: level % 2 === 0 ? 'phonemic' : 'semantic',
        targetScore: 7,
        label: 'Mode alterné, temps réduit',
    };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
export const timing = {
    primingMs: 800,
    feedbackMs: 1200,
    itiMs: 1000,
};
export const paradigmMeta = {
    slug: 'verbal-fluency',
    paradigm: 'Verbal Fluency Test (FAS, Lezak Neuropsy Assessment)',
    category: 'foudre_logique',
    goal: "Récupération lexicale stratégique : générer un max de mots en temps limité.",
};
//# sourceMappingURL=params.js.map